import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { NotSignedInError } from '../auth';
import { LoggerService } from '../logger';
import { CreateNotification } from '../store';
import * as i0 from "@angular/core";
export const GRPC_MESSAGE_HEADER = 'grpc-message';
export class ErrorHandlerService {
    // since ErrorHandler is instantiated before other providers, use injector to inject providers here
    constructor(injector) {
        this.injector = injector;
    }
    handleError(error) {
        if (error instanceof NotSignedInError) {
            return;
        }
        const store = this.injector.get(Store);
        const loggerService = this.injector.get(LoggerService);
        const router = this.injector.get(Router);
        console.error(error.message);
        console.error(error.stack);
        // Errors coming back from Http calls is not HttpErrorResponse
        // https://github.com/angular/angular/issues/27840
        while (error['rejection']) {
            error = error['rejection'];
        }
        // send error to server
        loggerService.error(error);
        if (error instanceof HttpErrorResponse) {
            const message = this.getHttpErrorMessage(error);
            // Show notification to the user
            return store.dispatch(new CreateNotification(`${message}`));
        }
        else {
            // Client Error happened
            // redirect the user to the page with all the info
            router.navigate(['/error'], {
                queryParams: { type: error.name, message: error.message }
            });
        }
    }
    getHttpErrorMessage(error) {
        // No Internet connection
        if (!navigator.onLine) {
            return 'The browser is offline, please check your network connection';
        }
        return error.headers.get(GRPC_MESSAGE_HEADER) || error.message;
    }
}
ErrorHandlerService.ngInjectableDef = i0.defineInjectable({ factory: function ErrorHandlerService_Factory() { return new ErrorHandlerService(i0.inject(i0.INJECTOR)); }, token: ErrorHandlerService, providedIn: "root" });
